
import router from './router'
import api from './api/login'
import store from './store'
router.beforeEach(async (to, from, next) => {
    // console.log('to',to)
    // console.log('from', from)
    // console.log('next', next)

    // console.log(api)
    // console.log(store)



    let redirectUrl = window.location.protocol+'//'+window.location.host+to.fullPath
    // redirectUrl = encodeURIComponent(redirectUrl)
    console.log('redirectUrl', redirectUrl)

    if (to.meta.noAuth) {
        console.log('不需要权限')
        next()
    } else {
        console.log('to',to.query.from)
        if(to.query.from && to.query.from=='back' && to.query.openid){
            console.log('后台进入')
            store.commit('setOpenid', to.query.openid)  // 保存返回openid
            let info=await api.userInfo({hideLoading:true})
            store.commit('setUserInfo', JSON.stringify(info.result))
            next()
        }else if(process.env.NODE_ENV=="development"){
            store.commit('setOpenid', 'oTvHBwfumwFOxF8jVZWGBhnBDttc')  // 保存返回openid
            let info=await api.userInfo({hideLoading:true})
            store.commit('setUserInfo', JSON.stringify(info.result))
            next()
        } else {
        console.log('需要权限')
        const code = to.query.code  // 截取url上的code ,可能没有,则返回''空字符串
        if (code) {  // 带code  进入 跳转链接获取 openid
            localStorage.removeItem('openid')
            // alert('带code进入，发请求code')
            console.log('带code进入', code)
            api.login({ code,hideLoading:true }).then(res=>{// 通过code获取 openid
                if (res.status == 0 && res.wxuser) {
                    // alert('获取用户',res.wxuser)
                    store.commit('setOpenid', res.wxuser.openid)  // 保存返回openid
                    // alert('拿到openid发请求获取用户信息')
                   api.userInfo({hideLoading:true}).then(info=>{ // 获取用户信息
                    if (info.status == 0 && info.result) {
                        store.commit('setUserInfo', info.result)
                        next()
                    } else {
                        // alert("用户信息获取 失败")
                        next({ name: 'error', query: { 'msg': 'userInfo:'+res.message } })
                    }
                   })   
                } else {
                    next({ name: 'error', query: { 'msg': `'login:'${res.message},code:${code}` } })
                }
            }) 

        } else { //  无 code  
            if (localStorage.getItem('openid')) {   // 判断本地有无openid
                next()
            } else {  // 本地无openid  // 重新登录
                // alert('跳转登录获取code2，无openid')
        const appid = 'wx11202b137e6aeacf'
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
            }
        }
        }

    }
})

export default router